module.exports = __webpack_public_path__ + "static/assets/704c3bff0d8ae1dd987c3edd3526c439.svg";